import Notifications from 'views/notifications/Notification.container';

export default Notifications;